var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"height":"calc(100vh - 172px)"},attrs:{"referrerpolicy":"origin-when-cross-origin","src":'https://insite.trungsonpharma.com/faq?token='+_vm.token,"frameborder":"0","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }